<template>
  <div class="max-w-3xl mx-auto py-4">
    <div class="bg-white p-4 rounded-md text-xl flex items-center flex-col">
      <h2
        class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight my-6"
      >
        Review products
      </h2>
      <div v-if="isLoading">
        <Spinner />
      </div>

      <div class="overflow-hidden rounded-md bg-white shadow w-full">
        <ul role="list" class="divide-y divide-gray-200">
          <li
            class="px-6 py-4 flex justify-between border border-gray-200"
            v-for="(lineItem, index) of lineItems"
            :key="index"
          >
            {{ lineItem.title }}
            <button
              type="button"
              class="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              @click="openSite(lineItem)"
            >
              Review
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";
import { format } from "date-fns";

export default {
  components: {
    Spinner
  },
  data() {
    return {
      store: {},
      confirmText: "",
      lineItems: [],
      isLoading: false
    };
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  created() {
    this.getJudgemeOrderdetails();

    // eslint-disable-next-line
    if ($crisp) {
      // eslint-disable-next-line
      $crisp.push(["do", "chat:hide"]);
    }
  },
  methods: {
    getJudgemeOrderdetails() {
      this.isLoading = true;
      const shortCode = this.$route.params.shortCode;
      this.$store
        .dispatch("getJudgemeOrderdetails", {
          shortCode
        })
        .then(response => {
          this.isLoading = false;
          if (response.order && response.store) {
            this.lineItems = response.lineItems;
            this.store = response.store;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    confirmOrder() {
      const shortCode = this.$route.params.shortCode;
      this.$store.dispatch("updateCodOrder", {
        requestParams: { isConfirmed: true },
        shortCode
      });
    },
    openSite(lineItem) {
      if (lineItem.reviewUrl) {
        // Check if the URL already contains query parameters
        if (lineItem.reviewUrl.includes("?")) {
          // If URL already has parameters, append with &
          window.open(`${lineItem.reviewUrl}&judgeme_token=1`, "_blank");
          return;
        } else {
          // If URL doesn't have parameters, append with ?
          window.open(`${lineItem.reviewUrl}?judgeme_token=1`, "_blank");
          return;
        }
      } else {
        const url = `https://${this.store.domain}/variants/${lineItem.variantId}`;
        window.open(url, "_blank");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
